/**
 * @module app.track.service
 */
import {VALID_RECORDEDTRACK_PROPS_FOR_UPDATE} from '../constants.js';

class TrackService {
  /**
   * @param {angular.$http} $http Angular Http service.
   * @param {angularGettext.Catalog} gettextCatalog
   * @param {string} apiUrl API url prefix.
   * @param {app.AuthenticationService} appAuthenticationService
   * @param {angular.$q} $q Angular Q service.
   * @param {app.waiting} appWaiting
   * @param {ngeo.statemanager.Location} ngeoLocation Location service from NGEO.
   * @ngInject
   */
  constructor($http, gettextCatalog, apiUrl, appAuthenticationService, $q, appWaiting, ngeoLocation) {

    /**
     * @private
     */
    this.ngeoLocation_ = ngeoLocation;

    /**
     * @private
     */
    this.http_ = $http;

    this.gettextCatalog = gettextCatalog;

    /**
     * @private
     */
    this.apiUrl_ = apiUrl;

    /**
     * @private
     */
    this.authentication_ = appAuthenticationService;


    /**
     * @private
     */
    this.q_ = $q;

    /**
     * @private
     */
    this.appWaiting_ = appWaiting;

    /**
     * @type {string}
     * @private
     */
    this.saveTrackConfigErrorMsg_ = gettextCatalog.getString('Error when saving track config');

    /**
     * @type {appx.TrackShowResponse|undefined}
     * @export
     */
    this.selectedTrack = undefined;

    /**
     * @type {Object}
     * @export
     */
    this.selectedTrackPois;

  }

  /**
   * @export
   * @param {number} maxPoints Maxiumum number of points to export.
   *   A 'null' value means no limit (all the points), an 'undefined' value uses the value from the
   *   track configuration.
   * @return {string}
   */
  gpsDownloadURL(maxPoints) {
    let maxPointsParam = '';
    if (maxPoints !== undefined) {
      maxPointsParam = `?maxPoints=${maxPoints === null ? '-1' : maxPoints}`;
    }
    const api = this.selectedTrack.recorded ? '5/recordedtracks/' : '4/tracks/';
    return `${this.apiUrl_}${api}${this.selectedTrack.id}/export_gps${maxPointsParam}`;
  }

  /**
   * @export
   * @return {boolean}
   */
  ownSelectedTrack() {
    const selectedTrack = this.selectedTrack;
    return selectedTrack ? this.authentication_.userId === selectedTrack.properties.owner && this.authentication_.subscriptionOk : false;
  }

  /**
   * @param {appx.TrackShowResponse} track
   */
  saveTrackConfig(track) {
    this.appWaiting_.increment();

    console.assert(track.id !== undefined);
    const api = track.recorded ? `5/recordedtracks/${track.id}` : `4/tracks/${track.id}/save_params`;
    let data = {
      'color': track.properties.color,
      'gpspoints': track.properties.gpspoints,
      'opacity': track.properties.opacity,
      'timetype': track.properties.timetype,
      'velospeed': track.properties.velospeed,
      'public': !!track.properties.public // possible value null but service accepts only boolean
    };
    if (track.recorded) {
      data = {
        properties: this.createRecordedTrackPropertiesForUpdate(track.properties)
      };
    }
    return this.http_.put(`${this.apiUrl_}${api}`, data)
      .catch((err) => {
        if (err.status != 200) {
          if (err.status == 401) {
            this.authentication_.delog();
          } else {
            bootbox.alert({message: this.saveTrackConfigErrorMsg_});
          }
        }
      })
      .finally(() => {
        this.appWaiting_.decrement();
      });
  }

  createRecordedTrackPropertiesForUpdate(properties) {
    const validProperties = {};
    VALID_RECORDEDTRACK_PROPS_FOR_UPDATE.forEach(key => {
      const value = properties[key];
      if (value !== undefined) {
        validProperties[key] = value;
      }
    });
    return validProperties;
  }
}

export default angular.module('appTrackService', []).service('appTrackService', TrackService);
